/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import Typography from 'core/ui/Typography';
import Box from 'core/ui/Box';
import SFDataTable from 'core/ui/DataTable';
import { useTranslation } from 'react-i18next';
import MIcon from 'core/ui/MIcon';
import { IconButton, Tooltip } from '@material-ui/core';
import { Delete, Edit, FileCopy, FolderOpen } from '@material-ui/icons';
import Divider from 'core/ui/Divider';
import { gymDate, time } from 'core/utils/formatters';

const TableWorkflows = ({
  workflows,
  viewClick,
  removeClick,
  templates,
  isStreamChannel,
  cloneTemplate,
  clone,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      selector: 'name',
      sortable: true,
      width: '40px',
      cell: (workflow) => (
        <div>
          <MIcon icon={workflow?.automationType?.icon} />
        </div>
      ),
    },
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      cell: (workflow) => (
        <div>
          <Typography className="tw-font-semibold tw-text-zinc-800" noWrap>
            {workflow?.name}
          </Typography>
          <Typography className="tw-text-xs tw-font-normal tw-text-green-700" noWrap>
            {workflow?.automationType?.name}
          </Typography>
        </div>
      ),
    },
    {
      name: 'Status',
      selector: 'status',
      sortable: true,
      cell: (workflow) => (
        <Typography
          noWrap
          className={`tw-rounded-full tw-border tw-border-solid tw-p-1 tw-text-[10px] tw-font-semibold ${workflow.status === 'active' ? 'tw-border-green-300 tw-bg-green-100 tw-text-green-500' : 'tw-border-gray-300 tw-bg-gray-100 tw-text-gray-500'}`}
        >
          {workflow.status?.toUpperCase()}
        </Typography>
      ),
    },

    {
      name: 'Created',
      selector: 'createdAt',
      sortable: true,
      cell: (workflow) => (
        <Typography className="tw-text-xs tw-text-gray-700" noWrap>
          {gymDate(workflow?.createdAt)}&nbsp;{time(workflow?.createdAt)}
        </Typography>
      ),
    },
    {
      name: 'Last Run',
      selector: 'lastExecutionAt',
      sortable: true,
      cell: (workflow) =>
        workflow?.lastExecutionAt && (
          <Typography className="tw-text-xs tw-text-gray-700" noWrap>
            {gymDate(workflow?.lastExecutionAt)}&nbsp;{time(workflow?.lastExecutionAt)}
          </Typography>
        ),
    },

    {
      name: '',
      selector: '',
      sortable: false,
      right: true,
      cell: (workflow) => (
        <Box className="tw-flex tw-flex-row tw-items-center tw-justify-end tw-gap-2">
          <>
            <Tooltip title={t(templates ? 'button.view' : 'button.edit')}>
              <IconButton size="small" onClick={() => viewClick(workflow)}>
                {!templates ? (
                  <Edit className="tw-text-gray-700" />
                ) : (
                  <FolderOpen className="tw-text-gray-700" />
                )}
              </IconButton>
            </Tooltip>
            <Divider orientation="vertical" flexItem />
          </>

          {!templates && (
            <>
              <Tooltip title={t('button.clone')}>
                <IconButton size="small" onClick={() => clone(workflow)}>
                  <FileCopy className="tw-text-gray-700" />
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem />
            </>
          )}
          {!!templates && (
            <>
              <Tooltip title={t('button.clone')}>
                <IconButton size="small" onClick={() => cloneTemplate(workflow)}>
                  <FileCopy className="tw-text-gray-700" />
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem />
            </>
          )}

          {(!templates || isStreamChannel) && (
            <Tooltip title={t('button.delete')}>
              <IconButton size="small" onClick={() => removeClick(workflow)}>
                <Delete className="tw-text-gray-700" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ].filter(
    (x) =>
      (x.name !== 'Status' && x.name !== 'Created' && x.name !== 'Last') ||
      isStreamChannel ||
      !templates,
  );

  return (
    <Box>
      <SFDataTable
        columns={columns}
        data={workflows}
        pagination
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => viewClick(row)}
        noTableHead={false}
        noHeader
        showPaper
        paginationPerPage={30}
      />
    </Box>
  );
};

TableWorkflows.propTypes = {};

TableWorkflows.defaultProps = {};

export default TableWorkflows;
